module.exports = __webpack_public_path__ + "img/協力旺.52cf573a.svg";